import { Link } from 'react-router-dom';
import { Logo } from '@/components/brand/Logo';
import { Button } from '@/components/ui';

const LINKS = [
  { href: '#features', label: 'Features' },
  { href: '#templates', label: 'Templates' },
  { href: '#how', label: 'How it works' },
] as const;

export function LandingNav() {
  return (
    <nav className="fixed inset-x-0 top-0 z-50 flex h-16 items-center border-b border-line/60 bg-canvas/80 backdrop-blur">
      <div className="mx-auto flex w-full max-w-container items-center justify-between px-6">
        <div className="flex items-center gap-10">
          <Link to="/" aria-label="Portfoli home">
            <Logo />
          </Link>
          <div className="hidden items-center gap-6 text-sm font-medium text-ink-muted md:flex">
            {LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="transition-colors hover:text-ink"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>
        <div className="flex items-center gap-4 text-sm font-medium">
          <Link to="/sign-in" className="hidden text-ink-muted transition-colors hover:text-ink md:block">
            Log in
          </Link>
          <Link to="/sign-in">
            <Button variant="primary" size="md">
              Get started
            </Button>
          </Link>
        </div>
      </div>
    </nav>
  );
}
